import React from 'react';
import type { CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { HalfScreenHero, type HalfScreenHeroProps } from '../HalfScreenHero';

export type ImageHalfScreenHeroProps = {
  image: CloudinaryImageFields;
} & Omit<HalfScreenHeroProps, 'media'>;

export const ImageHalfScreenHero = ({
  image,
  ctaCopy,
  ctaHref,
  CtaButton,
  CtaSecondaryButton,
  description,
  eyebrow,
  title,
  variant,
  signInUrl,
  contentOrder,
}: ImageHalfScreenHeroProps) => {
  return (
    <HalfScreenHero
      media={{
        type: 'image',
        ...image,
      }}
      description={description}
      eyebrow={eyebrow}
      title={title}
      variant={variant}
      signInUrl={signInUrl}
      contentOrder={contentOrder}
      {...(CtaButton ? { CtaButton } : { ctaCopy, ctaHref })}
      CtaSecondaryButton={CtaSecondaryButton}
    />
  );
};
